import React from 'react';
import { Button } from 'migration-flos-react';

export const InsuranceGuideInfo = ({ fsguide, setShowInsurances, showInsurances }) => (
    <div className="u-Space-down u-Space-up--lg">
        <h2 className="Section-header u-Space-down-lg">{fsguide.addinsurance.title}</h2>
        <Button
            variant="outline"
            onClick={() => setShowInsurances(!showInsurances)}
            minWidth="wide"
            data-testid="insurance-info-button"
        >
            {showInsurances ? fsguide.addinsurance.button.hide : fsguide.addinsurance.button.show}
        </Button>
    </div>
);
